import React from 'react';
import MuiChip from '@mui/material/Chip';

import { DesignTokenColor, palette } from '@src/theme';
import { getTestId } from '@src/utils/testIds';
import { Box } from '../Box';
import { HStack } from '../HStack';
import { Label } from '../Typography';
import { InfoBadgeProps } from './interface';

export const InfoBadge = ({ color, label, icon, ...otherProps }: InfoBadgeProps) => {
  let bgColor = palette.controls['backing+line'];
  let textColor: DesignTokenColor = 'text.secondary';
  switch (color) {
    case 'info':
      textColor = 'state.info.secondary';
      bgColor = palette.state.info['backing-1'];
      break;
    case 'error':
      textColor = 'state.error.secondary';
      bgColor = palette.state.error['backing-1'];
      break;
    case 'warning':
      textColor = 'state.warning.secondary';
      bgColor = palette.state.warning['backing-1'];
      break;
    case 'success':
      textColor = 'state.success.secondary';
      bgColor = palette.state.success['backing-1'];
      break;
  }
  return (
    <MuiChip
      data-testid={getTestId(otherProps)}
      sx={{
        borderRadius: '4px',
        bgcolor: bgColor,
        color: textColor,
        m: 0,
        px: 1,
        py: '2px',
        height: '20px',
        '& .MuiChip-label': {
          p: 0,
        },
      }}
      label={
        <HStack alignItems="center">
          {icon ? <Box mr={0.5}>{icon}</Box> : null}
          <Label size="xs" color={textColor}>
            {label}
          </Label>
        </HStack>
      }
    />
  );
};
